<template>
  <b-form-group
    label="Miktar Tipi"
    label-for="id_units"
  >
    <validation-provider
      #default="{ errors }"
      name="Miktar Tipi"
      rules="required"
    >
      <v-select
        v-model="dataItem.id_units"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Miktar Tipi"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'UnitsSelect',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['units/dataList']
    },
    dataItem() {
      return this.$store.getters['servicePrices/dataItem']
    },
  },
  created() {
    localize('tr')
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('units/getDataList')
    },
  },
}
</script>
